import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList'
import Collapsible from 'react-collapsible'

export default class RoomsFrame extends Component {

    state = {
        pages: [
            { key: '', label: '{{lang}}rooms.Enter Room', icon: '/assets/icons/rooms/enter-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'rooms', label: '{{lang}}rooms.Your Rooms', icon: '/assets/icons/rooms/rooms-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'schedule', label: '{{lang}}rooms.Schedule', icon: '/assets/icons/rooms/schedule-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'history', label: '{{lang}}rooms.History', icon: '/assets/icons/rooms/history-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        ],
        currentPage: '',
    }

    componentDidMount() {
    }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }
    changeFrame = (item) => {
        // console.log('this.props.changeFrame', this.props)
        if (this.props.changeFrame) {
            this.props.changeFrame(item.key)
        }
    }
    render() {
        // console.log('this.props.currentPage',this.props.currentPage)
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: this.props.color ?? '#fff' }}>{checkTranslation(this.state.pages?.find(el => el.key == this.props.currentPage)?.label) ?? translate('appletframe.Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={40} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-12} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <div className='white-bg' style={{}}>
                            {Array.isArray(this.state.pages) && this.state.pages.map((item, index) => {
                                return (
                                    <IntractionActionsList language={this.props.language} key={index} onClick={() => { this.changeFrame(item); this.framesOptionsList.hideView() }} data={{ title: item.label, icon: item.icon }} />
                                )
                            })}

                        </div>
                    </div>
                </FixedView >
            </div >
        )
    }
}
